import { render, staticRenderFns } from "./AuthBack.vue?vue&type=template&id=716c1b78&scoped=true&lang=pug&"
import script from "./AuthBack.vue?vue&type=script&lang=js&"
export * from "./AuthBack.vue?vue&type=script&lang=js&"
import style0 from "./AuthBack.vue?vue&type=style&index=0&id=716c1b78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c1b78",
  null
  
)

export default component.exports